"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SORTING_ITEMS = exports.SORT_NEWEST = exports.SORT_LESS_POPULAR = exports.SORT_MOST_POPULAR = exports.SORT_NAME_DESC = exports.SORT_NAME_ASC = exports.SORT_LESS_POPULAR_ID = exports.SORT_NEWEST_ID = exports.SORT_MOST_POPULAR_ID = exports.SORT_NAME_DESC_ID = exports.SORT_NAME_ASC_ID = void 0;
var SORT_NAME_ASC_ID = 1;
exports.SORT_NAME_ASC_ID = SORT_NAME_ASC_ID;
var SORT_NAME_DESC_ID = 2;
exports.SORT_NAME_DESC_ID = SORT_NAME_DESC_ID;
var SORT_MOST_POPULAR_ID = 3;
exports.SORT_MOST_POPULAR_ID = SORT_MOST_POPULAR_ID;
var SORT_NEWEST_ID = 4;
exports.SORT_NEWEST_ID = SORT_NEWEST_ID;
var SORT_LESS_POPULAR_ID = 5;
exports.SORT_LESS_POPULAR_ID = SORT_LESS_POPULAR_ID;
var SORT_NAME_ASC = {
  id: SORT_NAME_ASC_ID,
  label: 'Name (A-Z)',
  value: {
    column: 'name',
    order: 'asc'
  }
};
exports.SORT_NAME_ASC = SORT_NAME_ASC;
var SORT_NAME_DESC = {
  id: SORT_NAME_DESC_ID,
  label: 'Name (Z-A)',
  value: {
    column: 'name',
    order: 'desc'
  }
};
exports.SORT_NAME_DESC = SORT_NAME_DESC;
var SORT_MOST_POPULAR = {
  id: SORT_MOST_POPULAR_ID,
  label: 'Most popular',
  value: {
    column: 'popularity',
    order: 'desc'
  }
};
exports.SORT_MOST_POPULAR = SORT_MOST_POPULAR;
var SORT_LESS_POPULAR = {
  id: SORT_LESS_POPULAR_ID,
  label: 'Less popular',
  value: {
    column: 'popularity',
    order: 'asc'
  }
};
exports.SORT_LESS_POPULAR = SORT_LESS_POPULAR;
var SORT_NEWEST = {
  id: SORT_NEWEST_ID,
  label: 'Alyce curated',
  value: {
    column: 'alyce_curated',
    order: 'desc'
  }
};
exports.SORT_NEWEST = SORT_NEWEST;
var SORTING_ITEMS = [SORT_NAME_ASC, SORT_NAME_DESC, SORT_MOST_POPULAR, SORT_NEWEST];
exports.SORTING_ITEMS = SORTING_ITEMS;